export default __webpack_public_path__ + "static/media/fam7.4d56bc2f.png";